import {
	EVENT_ACTION_PARKING_PRODUCTS_EXTRAS_MORE_INFO,
	EVENT_CATEGORY_PARKING_PRODUCTS,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackClickedExtrasMoreInfo(title?: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_PRODUCTS,
		action: EVENT_ACTION_PARKING_PRODUCTS_EXTRAS_MORE_INFO,
		label: title,
	});
}
